import { render, staticRenderFns } from "./CriarConteudo.vue?vue&type=template&id=670fc57a&scoped=true&"
import script from "./CriarConteudo.vue?vue&type=script&lang=js&"
export * from "./CriarConteudo.vue?vue&type=script&lang=js&"
import style0 from "./CriarConteudo.vue?vue&type=style&index=0&id=670fc57a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670fc57a",
  null
  
)

export default component.exports